export default {
  'title': '指标管理',
}
